import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from '@progress/kendo-angular-dialog';
import { ButtonModule } from '@progress/kendo-angular-buttons';
import { DialogService } from '../../services/dialog.service';

/**
 * Componente que renderiza un diálogo de confirmación (Kendo UI)
 * controlado enteramente por el estado centralizado en DialogService.
 *
 * Este componente NO tiene @Inputs ni @Outputs directos:
 * - Se subscribe a dialog.state() (signal) para saber qué mostrar.
 * - Llama a métodos del servicio para confirmar o cancelar.
 *
 * Debe colocarse típicamente en un punto alto de la jerarquía de componentes
 * (por ejemplo, en AppComponent), para poder ser utilizado en toda la aplicación.
 */
@Component({
  selector: 'app-confirm-dialog',
  standalone: true,
  imports: [CommonModule, DialogModule, ButtonModule],
  template: `
    <!-- Mostrar el diálogo solo si visible es true -->
    @if (dialog.state().visible) {
      <kendo-dialog
        [title]="dialog.state().title"
        (close)="dialog.cancelAction()"
      >
        <!-- Cuerpo del mensaje -->
        <p class="text-base">{{ dialog.state().message }}</p>

        <!-- Botones de acción -->
        <kendo-dialog-actions>
          <button kendoButton (click)="dialog.cancelAction()">No</button>
          <button kendoButton themeColor="primary" (click)="dialog.confirmAction()">Sí</button>
        </kendo-dialog-actions>
      </kendo-dialog>
    }
  `
})
export class ConfirmDialogComponent {
  /**
   * Inyectamos el servicio global para acceder a:
   * - El estado (dialog.state()) -> signal
   * - Acciones para confirmar/cancelar
   */
  dialog = inject(DialogService);
}
